import { Component, EventEmitter, Input, Output } from '@angular/core';

const CHART_TYPE_LABELS: Record<string, string> = {
  bar: 'Barras',
  line: 'Línea',
  pie: 'Torta',
  doughnut: 'Dona',
  radar: 'Radar',
  polarArea: 'Área polar',
};

@Component({
  selector: 'app-ai-chat-options',
  templateUrl: './ai-chat-options.component.html',
  styleUrls: ['./ai-chat-options.component.scss'],
})
export class AiChatOptionsComponent {
  @Input() optionsData!: { options: string[]; message?: string };
  @Output() optionSelected = new EventEmitter<string>();

  getOptions(): string[] {
    return Array.isArray(this.optionsData?.options) ? this.optionsData.options : [];
  }

  getLabel(type: string): string {
    return CHART_TYPE_LABELS[type] || type;
  }

  selectOption(type: string): void {
    this.optionSelected.emit(type);
  }
}
